import React from 'react';
import frontendImg from '../../assets/images/front-end.png';
import backendImg from '../../assets/images/backend.png';

const Services = () => {
  return (
    <section id="services">
      <div className="container lg:pt-5">
        <div className="text-center">
          <h2 className="text-headingColor text-[2rem] font-[800] mb-5 ">What I Do</h2>
          <p className="lg:max-[600px] lg:max-auto text-smallTextColor font-semibold text-[16px] leading-7">
            Working on both the front-end and back-end of a website or application. I am proficient in a wide range of technologies, including HTML, CSS, JavaScript, Next.js, React, Java, C++, and Rails. I am also responsible for the entire development lifecycle, from conception to deployment. Collaborate with designers, project managers, and other developers to create and maintain high-quality software.
          </p>
        </div>
        <div className="flex flex-col justify-center sm:py-12">
          <div className="w-full py-3 px-2 sm:max-w-xl sm:mx-auto sm:px-0">
            <div className="relative text-primaryColor antialiased text-sm font-semibold">
              <div className="hidden absolute w-1 sm:block bg-primaryColor h-full left-1/2 transform-translate-x-1/2"></div>
              <div className="mt-6 sm:mt-0 sm:mb-12">
                <div className="flex items-center flex-col sm:flex-row">
                  <div className="flex justify-start w-full mx-auto items-center">
                    <div className="w-full sm:w-1/2 sm:pr-8">
                      <div data-aos="fade-right" data-aos-duration="1500" className="p-4 rounded-none shadow-white group cursor-pointer ease-in duration-300 hover:bg-primaryColor border border-white">
                        <h3 className="text-headingColor font-bold mb-3 group-hover:font-normal group-hover:text-white text-2xl">Frontend Dev</h3>
                        <p className="text-smallTextColor text-[15px] group-hover:font-normal group-hover:text-white">
                          Responsible for the client-side development of web applications. My primary focus is on creating an engaging and user-friendly interface that interacts with the users using HTML, Vanilla CSS, JavaScript, React, and Git.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-full bg-primaryColor border-white border-2 w-10 h-10 absolute left-1/2 transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center">
                    <figure>
                      <img src={frontendImg} alt="frontimg" />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="mt-6 sm:mt-0 sm:mb-12">
                <div className="flex items-center flex-col sm:flex-row">
                  <div className="flex justify-end w-full mx-auto items-center">
                    <div className="w-full sm:w-1/2 sm:pl-8">
                      <div data-aos="fade-left" data-aos-duration="1500" className="p-4 rounded-none shadow-white group cursor-pointer ease-in duration-300 hover:bg-primaryColor border border-white">
                        <h3 className="text-headingColor font-bold mb-3 group-hover:font-normal group-hover:text-white text-2xl">Backend Dev</h3>
                        <p className="text-smallTextColor text-[15px] group-hover:text-white group-hover:font-normal">
                          Responsible for the server-side development of web applications and the underlying systems that support them. I handle the logic and data processing that happens behind the scenes using Ruby on Rails, PostgreSQL, API integration, and Git.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-full bg-primaryColor border-white border-2 w-10 h-10 absolute left-1/2 transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center">
                    <figure>
                      <img src={backendImg} alt="backimg" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;